import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  currentRout(path): boolean {
      const loc = window.location.href;
      return loc.includes(path);
  }

}
